import React from 'react';
import { ArrowDownIcon } from 'lucide-react';
import { SOLUTIONS } from '../../data/solutions';
import { AGENT_CATEGORIES } from '../../data/agents';
import { AgentIcon } from './AgentIcon';

/** Six solutions → one DiligenceGPT core → eight agent layers. Stacks into three groups on mobile. */
export function SolutionsStackDiagram() {
  return <figure aria-label="Different processes, same infrastructure" className="rounded-2xl border border-hairline bg-panel p-4 sm:p-8" data-id="element-1245" data-mp="13ul3k5y4za1a">
      <ul className="grid grid-cols-2 gap-2 sm:grid-cols-3 lg:grid-cols-6" data-id="element-1246" data-mp="b6fjllewpp2i">
        {SOLUTIONS.map(solution => <li key={solution.id} className="rounded-lg border border-hairline bg-surface px-3 py-3 text-center text-[13px] font-semibold uppercase tracking-[0.08em] text-text-primary" data-id="element-1247" data-mp="g58posrv6dsn">
            {solution.label}
          </li>)}
      </ul>

      <div className="relative my-4 hidden h-10 lg:block" aria-hidden="true" data-id="element-1248" data-mp="3olbw6v78pwfe">
        {SOLUTIONS.map((solution, index) => <span key={solution.id} className="absolute top-0 h-full w-px bg-hairline" style={{
        left: `${(index + 0.5) / SOLUTIONS.length * 100}%`
      }} data-id="element-1249" data-mp="3a1iwk6jzd1cj" data-mpi={index} />)}
        <span className="absolute bottom-0 left-[8.33%] right-[8.33%] h-px bg-hairline" data-id="element-1250" data-mp="30bg7ghfzc7jh" />
      </div>
      <div className="my-3 flex justify-center text-text-tertiary lg:hidden" aria-hidden="true" data-id="element-1251" data-mp="2vcwie863afmw">
        <ArrowDownIcon className="h-4 w-4" data-id="element-1252" data-mp="2rcugpz0ctm7m" />
      </div>

      <div className="mx-auto max-w-md rounded-xl bg-night px-6 py-5 text-center" data-id="element-1253" data-mp="2md9gll9g77tb">
        <p className="text-[11px] font-semibold uppercase tracking-[0.14em] text-night-faint" data-id="element-1254" data-mp="2mfcesskr8794">One platform</p>
        <p className="mt-1 text-xl font-semibold tracking-[-0.01em] text-night-text" data-id="element-1255" data-mp="2cetqnlm5q4le">DiligenceGPT</p>
      </div>

      <div className="my-3 flex justify-center text-text-tertiary" aria-hidden="true" data-id="element-1256" data-mp="fn1ws5cmvvif">
        <ArrowDownIcon className="h-4 w-4" data-id="element-1257" data-mp="anfgto5f815x" />
      </div>

      <ul className="grid grid-cols-2 gap-2 sm:grid-cols-4 lg:grid-cols-8" data-id="element-1258" data-mp="anypsfd3ff7t">
        {AGENT_CATEGORIES.map(category => <li key={category.id} className="flex items-center gap-2 rounded-lg border border-lime/20 bg-violet-soft px-3 py-2.5 lg:flex-col lg:text-center" data-id="element-1259" data-mp="251ugsmqc8zr6">
            <AgentIcon category={category.id} className="h-4 w-4 shrink-0 text-lime" data-id="element-1260" data-mp="1v6sr9ps5hvo2" />
            <span className="text-[13px] font-semibold uppercase tracking-[0.04em] text-lime" data-id="element-1261" data-mp="203svdv5fwocj">{category.stage}</span>
          </li>)}
      </ul>
      <figcaption className="mt-6 text-center text-sm font-medium text-text-secondary" data-id="element-1262" data-mp="2nsc60hbypd7s">Different processes. Same infrastructure.</figcaption>
    </figure>;
}